<template>
    <div class="design-wrapper">
		<div class="sidebar">
			<router-link :to="item.path" v-for="item in menuList" :key="item.name" class="menu-item" :class="{'active-menu': ((route?.name === 'orderDetail' || route?.name === 'designAccept') && item.name==='designOrder') || (item.name === 'designCase' && (route?.name === 'design' || route?.name === 'designhome'))}">
				<!-- <xl-icon :class="item.icon"></xl-icon> -->
				<svg class="icon svg-icon icon-img" style="font-size: 16px;" aria-hidden="true">
					<use :xlink:href="`#${item.icon}`"></use>
				</svg>
				<div class="tlt">{{ item.title }}</div>  
			</router-link>
		</div>
		<div class="content">
			<router-view v-slot="{ Component }">
				<keep-alive :include="cacheComps">
					<component v-if="keepAlive" :is="Component" :key="route.path" />
				</keep-alive>
				<component v-if="!keepAlive" :is="Component" :key="route.path" />
			</router-view>
		</div>
		<Privacy ref="privacy" :privacyPolicyHtml="privacyPolicyHtml" :termsOfUseHtml="termsOfUseHtml" :privacyVersion="privacyVersion" :termsOfUseVersion="termsOfUseVersion" @agreeAndContinue="agreeAndContinue"></Privacy>
		<InstitutionalVerificationDialog ref="InstitutionalVerificationDialogRef"/>
		<PreprintList></PreprintList>
	</div>
</template>

<script setup>
import { XlMenu, XlMenuItem, XlIcon } from "@shining3d/ui-components";
import { ref, watch, computed, onMounted } from 'vue';
import '@shining3d/common-module/utils/index.scss'
import serviceTermsApi from "../api/serviceTerms"
import printApi from "../api/print";
import InstitutionalVerificationDialog from "../components/InstitutionalVerificationDialog.vue"
import PreprintList from "../components/preprintList/index.vue";
import creditCardApi from "../api/creditCard";
import Privacy from '../components/privacy.vue';
import { langMap } from '../common/enum';
import { $getLocalStorage, $setLocalStorage } from '@shining3d/common-module/utils/index.js';
import { useRouter, useRoute } from 'vue-router';
import { VueCookieNext } from 'vue-cookie-next';

import router from '@/router';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import _get from 'lodash/get';
import { useStore } from "vuex";

const { $t } = useLang("@shining3d/xl-design-order");
const $store = useStore();
const route = computed(()=>router.currentRoute.value);
const userId = VueCookieNext.getCookie( 'user_id' );
const privacy = ref(null);
const keepAlive = computed(() => router.currentRoute.value.name === 'designOrder');
const needCacheRoutes = ['designOrder', 'designAccept', 'orderDetail'];
const cacheComps = ref(needCacheRoutes);

const InstitutionalVerificationDialogRef =ref(null)
const EuropeanUnion = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
const currentOrganization = $getLocalStorage( 'currentOrganization' )
const agreeAndContinue =()=>{
	// 判断国家是否需要vat验证
	if (EuropeanUnion.includes(currentOrganization?.country) && !currentOrganization?.vat && !$getLocalStorage('isNoNeedCertifyTip')) {
		const url = '/u/institution-setting/' + currentOrganization?.id +'/uniqueness'
		InstitutionalVerificationDialogRef.value.open({url:url})
	}
}
const menuList = [
	{ 
		name: 'designCase',
		icon: 'icon-a-SJNewrequirement-converted3',
		title: $t('design.case.createRequirement') || "新建需求",
		key:"Case",
		path:"/u/design/case"
	},
	{	
		name: 'designOrder',
		icon: 'icon-a-Designorder',
		title: $t('design.order.orderTitle') || "设计订单",
		key:"Order",
		path:'/u/design/order'
	},
	{	
		name: 'designPreference',
		icon: 'icon-a-SJpreference',
		title: $t('design.preference.title') || "设计偏好",
		key: "Preference",
		path:'/u/design/preference'
	},
	{	
		name: 'designPrice',
		icon: 'icon-a-SJPriceList2',
		title: $t('design.priceList.title') || "价目表",
		key:"Price",
		path:'/u/design/prices'
	},
	{	
		name: 'designTerm',
		icon: 'icon-a-SJPrivacyPolicy',
		title: $t('design.serviceTerm') || "服务条款",
		key:"Term",
		path:'/u/design/terms'
	}
];
const lang = ref( VueCookieNext.getCookie( 'lang' ));
const privacyPolicyHtml = ref('');
const termsOfUseHtml = ref('');
// 隐私政策版本号
const privacyVersion = ref()
// 用户条款版本号
const termsOfUseVersion = ref()
// 机构id
const institutionId = _get( $store, 'state.factorySelect.id', '' );
// 触发云切权限
$store.dispatch( 'getSlicePower' );

watch(() => route.value, ( val ) => {
	if ( !needCacheRoutes.includes( val.name ) ) {
		cacheComps.value = []
	} else {
		cacheComps.value = [needCacheRoutes];
	}
});

const checkComplianceVersion = () => {
	const params = {
        lang: langMap.get(lang.value), 
        associatedSystem: 'dentalx', 
        nameCodes: ['privacy', 'termsOfUse']
    }
	serviceTermsApi.checkComplianceVersion( params ).then(res => {
		if( res && res.status === 'success') {
        const needAgreed = res?.result?.contents?.some((item) => item.needAgreed);
			if(needAgreed){
				res?.result?.contents?.forEach((item) => {
					if( item?.nameCode === 'privacy'){
						privacyPolicyHtml.value = item.content;
						privacyVersion.value = item.version;
					} else if(item?.nameCode === 'termsOfUse') {
						termsOfUseHtml.value = item.content;
						termsOfUseVersion.value = item.version;
					}
				})
				privacy.value.open(); 
			}else{
				agreeAndContinue()
			}
		} else {
			router.push({
                path: '/u/cases'
            });
		}
	})
}
watch(()=>route.value, (val)=>{
	if( ['designCase', 'designOrder', 'designPrices', 'designPreference', 'designTerms'].includes(val?.name) ){
		checkComplianceVersion();
	}
},{ deep: true, immediate: true })

// onMounted(() => {
// 	checkComplianceVersion();
// 	// 获取是否有默认信用卡
// 	creditCardApi.getPayCard({businessID: institutionId, platform: window.app?.entryName || 'dental'}).then((res) => {
//     if( res && res.status === 'success' ){
//       if(res?.result?.find((item) => item?.isDefault === 'y')){
//         $setLocalStorage('hasDefaultCard', true);
//       }
//     }
//   })
// });
// privacy.value.open();


</script>

<style lang="scss" scoped>
.design-wrapper{
	display: flex;
	height: 100%;
	width: 100%;

	.sidebar {
		width: 84px;
		height: 100%;
		min-width: 84px;
		padding: 24px 0;
		background: white;
		box-shadow: inset 0px 0px 0px 1px #E0E4EA;
		box-sizing: border-box;

		.tlt {
			font-size: 12px;
			line-height:18px;
			margin-top: 2px;
			color: #737E99;
		}

		a {
			display: block;
			padding: 0px;
			text-decoration: none;
			color: #333;
		}
		.router-link-active{
			background: #edf3ff;
			.icon-img{
				color: #5587FF !important;
			}
			.tlt{
				color: #5587FF !important;
			}
		}
		.active-menu{
			background: #edf3ff;
			.icon-img{
				color: #5587FF !important;
			}
			.tlt{
				color: #5587FF !important;
			}
		}
		.menu-item {
			min-height: 32px;
			font-size: 12px;
			font-family: aliFontT;
			color: #42526e;
			cursor: pointer;
			border-radius: 6px;
			padding: 8px 0 8px 0;
			text-align: center;
			margin: 0px 8px 12px 8px;
		}
		.is_selected {
			background: #EDF3FF;
			color:#5587FF;
			svg{
				fill:#5587FF
			}
		}
	}
	.content {
		flex: 1;
		overflow: hidden;
	}
}
</style>